import logo from "./logo.svg";
import "./App.css";
import MyRoute from "./route";
import "bootstrap/dist/css/bootstrap.min.css";
import firebase from "firebase";
import store from "./Redux/store";
import { Provider } from "react-redux";

var firebaseConfig = {
  apiKey: "AIzaSyBwCzxaBdsivwqMkWGctE_YhbCp_8_PIj8",
  authDomain: "saylani-sbil.firebaseapp.com",
  projectId: "saylani-sbil",
  storageBucket: "saylani-sbil.appspot.com",
  messagingSenderId: "624120680356",
  appId: "1:624120680356:web:46d8adff9fad47e54c3b31",
  measurementId: "G-5R25GB1351",
};

firebase.initializeApp(firebaseConfig);
firebase.analytics();

function App() {
  return (
    <div
      className="App"
      style={{ backgroundColor: "#eaf3ff", height: "100%", minHeight: "100vh" }}
    >
      <Provider store={store}>
        <MyRoute />
      </Provider>
    </div>
  );
}

export default App;
